import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
  } from "@material-ui/core";
  import * as React from "react";
  
  // tslint:disable-next-line:no-empty-interface
  export interface ITableProductRelationPros {
    rows?: any[];
    columns: any[];
  }

  function TableProductRelation(props: ITableProductRelationPros) {
    const { rows, columns } = props;
    
    const getKey = () => {
      return Math.random() * 12;
    };
    
    const getCell = (header: any) => {
      return <TableCell key={getKey()}>{header.title}</TableCell>
    }

    const getCellRow = (row: any, item: any) => {
      return <TableCell key={getKey()}>{item.render(row)}</TableCell>
    }
    
    return (
      <div>
          <div>
            <Table>
              <TableHead>
                <TableRow>
                  {columns.map((v) => (getCell(v)))}
                </TableRow>
              </TableHead>
              {rows && rows.length > 0 && (
                <TableBody>
                  {rows.map((row: any, index) => (
                    <TableRow key={index}>
                      {columns.map((v) => (
                        getCellRow(row, v)
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
          </div>
      </div>
    );
  }
  export default TableProductRelation;


// WEBPACK FOOTER //
// ./src/component/administration/registers/product-grouping-new/TableProductRelation.tsx